<aside class="chat-slideout-panel" role="dialog" aria-label="AI chat assistant" [attr.aria-modal]="isOpen()" [attr.aria-hidden]="!isOpen()">
	<div class="chat-slideout-header">
		<div class="chat-slideout-header__title">
			<md-icon [icon]="'untitled-ui/communication/message-chat-circle'"></md-icon>
			<md-header size="sm">KnowledgeBird</md-header>
		</div>
		<div class="chat-slideout-header__actions">
			<button class="chat-slideout-header__action-btn" (click)="toggleExpand()" [attr.aria-label]="isExpanded() ? 'Collapse chat' : 'Expand chat'">
				@if (isExpanded()) {
					<md-icon [icon]="'untitled-ui/layout/minimize-01'"></md-icon>
				} @else {
					<md-icon [icon]="'untitled-ui/layout/maximize-01'"></md-icon>
				}
			</button>
			<button class="chat-slideout-header__action-btn" (click)="close()" aria-label="Close chat">
				<md-icon [icon]="'untitled-ui/general/x-close'"></md-icon>
			</button>
		</div>
	</div>

	@if (activeThread()) {
		<lb-chat-message-area
			[conversation]="activeThread()!"
			[messages]="messages()"
			[loading]="loading()"
			[userInitials]="userInitials()"
			[showMenuToggle]="false"
			(messageSent)="sendMessage($event)"
		/>
	} @else if (isOpen()) {
		<div class="chat-slideout-loading">
			<span>Loading...</span>
		</div>
	}
</aside>
